import { Component, Input, inject } from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ProjectReferenceViewModeService} from '../../services/project-reference-view-mode.service';

@Component({
    selector: 'app-copy-to-clipboard',
    templateUrl: './copy-to-clipboard.component.html',
    standalone: false
})
export class CopyToClipboardComponent {
    private toast = inject(ToastrService);
    private projectReferenceViewModeService = inject(ProjectReferenceViewModeService);

    @Input() value: string | undefined;

    mode$ = this.projectReferenceViewModeService.mode$;

    copyToClipboard() {
        if (this.value) {
            window.navigator.clipboard.writeText(this.value);
            this.toast.info('Tekst gekopieerd naar het klembord');
        }
    }
}
